<template>
  <div class="container">
     <div class="form">
         <div class="title">
             <div class="title1">起重机械生产企业</div>
            <div class="title2">安全智能综合监管平台</div>
         </div>
         <div class="inputdiv">
             <i class="iconfont">&#xe609;</i>
             <input type="text" placeholder="手机号" v-model="phone">
         </div>
         <div class="inputdiv" style="margin-top:30px">
             <i class="iconfont" style="color:#7194F3">&#xe608;</i>
             <input type="password" placeholder="密码" v-model="pwd">
         </div>
         <button class="btn" @click="login">登 录</button>
     </div>
     <footer class="foot">
          易方汇智科技有限公司     版权所有©2021    客服热线：400-8521-747
            <a style="color: #aaa" href="https://beian.miit.gov.cn/#/Integrated/index">    蜀ICP备20006618号-3</a>
      </footer>
  </div>
</template>

<script>
import sha1 from '../assets/js/sha1';
export default {
    data(){
        return{
            phone:'',
            pwd:'',
        }
    },
    mounted(){
        this.$nextTick(()=>{
            document.onkeypress =  (e) => {
                var e = e || window.event
                if(e.keyCode == 13){
                    this.login();
                }
            }
        })
    },
    methods:{
        login(){
            var rules = /^1[123456789]\d{9}$/;
            if(this.phone == ''){
                this.$message({
                    message: '手机号为空！',
                    type: 'error'
                })
                return;
            }
            if(this.pwd == ''){
                this.$message({
                    message: '密码为空！',
                    type: 'error'
                })
                return;
            }
            if(!rules.test(this.phone)){
                this.$message({
                    message: '手机号格式错误！',
                    type: 'error'
                })
                return;
            }
            var password = sha1(this.pwd);
            this.$api.login({account:this.phone,password}).then(res=>{
                //登录失败
                if(res.data.code == 100){
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    })
                    return;
                }else{
                    //登录成功
                    async function saveLocalStorage () {
                        localStorage.setItem('user',JSON.stringify(res.data.data));
                    }
                    saveLocalStorage().then(()=>{
                        if(res.data.data.systemRole !=6 && res.data.data.systemRole !=0){
                            this.$router.push('/BigScreen')
                        }else{
                            this.$router.push('/Index')
                        }
                    })
                }
            })
        },
    },
    destroyed(){
        document.onkeypress =  null
    }
}
</script>

<style lang="scss" scoped>
.container{
   width: 100%;
   height: 100%;
   background: url('../assets/images/login_back.webp') no-repeat center center;
   background-size: 100% 100%;
   position: relative;
}
.iconfont{
    font-family:"iconfont" !important;
    font-size: 27px;
    font-style: normal;
    color: #EDB941;
}
.form{
    width: 25rem;
    height: 31.25rem;
    position: absolute;
    top: 19%;
    right: 6.375rem;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0 3.0625rem;
    .title{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 3.375rem;
        margin-bottom: 3.25rem;
    }
    .inputdiv{
        border-bottom: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        height: 10%;
        padding: 0 0.625rem;
        input:-webkit-autofill {
            -webkit-text-fill-color: #fff !important;/*记住密码的字的颜色*/
            transition: background-color 5000s ease-in-out 0s;/*延时渲染背景色来去除背景色*/
            caret-color: #fff;/*光标颜色*/
        }
        input{
            background: none !important;
            height: 100% !important;
            flex: 1;
            margin-left: 10%;
            color: #fff;
            font-size: 15px;
        }
        input:focus {  /*外边框线去除*/
            outline: none; 
        }
        input::placeholder{
            color: #fff;
            font-size: 15px;
        }
    }
    .btn{
        width: 303px;
        height: 40px;
        background: #EDB941;
        border-radius: 5px;
        outline:none;
        border: none;
        cursor: pointer;
        color: #fff;
        font-weight: bold;
        font-size: 17px;
        margin-top: 3.125rem;
    }
    .btn:active{
        background: rgba($color: #EDB941, $alpha: 0.9);
    }
}
.foot{
    position: fixed;
    bottom: 2%;
    width: 100%;
    text-align: center;
    height: 16px;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #aaa;
    letter-spacing: 1px;
}
</style>